import { render, staticRenderFns } from "./IconLogoInverted.vue?vue&type=template&id=6812f8ff&scoped=true"
import script from "./IconLogoInverted.vue?vue&type=script&lang=js"
export * from "./IconLogoInverted.vue?vue&type=script&lang=js"
import style0 from "./IconLogoInverted.vue?vue&type=style&index=0&id=6812f8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812f8ff",
  null
  
)

export default component.exports